<script setup lang="ts">
import { ref } from "vue";

definePage({
  meta: {
    action: "manage",
    subject: "UPDATEPWD",
  },
});

const count = ref(0);
const form = ref({
  oldPwd: "",
  newPwd: "",
  newPwdCheck: "",
  userNo: "",
});

const isPasswordVisible = ref(false);

const updatePassword = async (form: any) => {
  if (form.newPwd !== form.newPwdCheck) {
    $swal({
      icon: "warning",
      title: "密碼不一致",
      confirmButtonText: "關閉",
    });
  }
  const userData = useCookie("userData").value;
  form.userNo = userData.userno;

  await $api("/du/user/password/updatePassword", {
    method: "PUT",
    body: {
      oldPwd: form.oldPwd,
      newPwd: form.newPwd,
      newPwdCheck: form.newPwdCheck,
      userNo: form.userNo,
    },
  }).then(() => {
    $swal({
      title: "密碼修改成功",
      text: "請重新登入",
      icon: "success",
    });
  });
};
</script>

<template>
  <h1 class="text-h3 text-center">變更密碼</h1>
  <VRow no-gutters class="auth-wrapper bg-surface">
    <VCol>
      <div class="position-relative bg-background w-100 me-0">
        <div
          class="d-flex align-center justify-center w-100 h-100"
          style="padding-inline: 100px"
        >
          <VCard flat :max-width="500" class="mt-12 pa-6">
            <VCardText>
              <VForm @submit.prevent="() => {}">
                <VRow>
                  <VCol cols="12">
                    <AppTextField
                      v-model="form.oldPwd"
                      autofocus
                      placeholder="請輸入舊密碼"
                      :type="isPasswordVisible ? 'text' : 'password'"
                      :append-inner-icon="
                        isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'
                      "
                      @click:append-inner="
                        isPasswordVisible = !isPasswordVisible
                      "
                    />
                  </VCol>

                  <VCol cols="12">
                    <AppTextField
                      v-model="form.newPwd"
                      placeholder="請輸入新密碼"
                      :type="isPasswordVisible ? 'text' : 'password'"
                      :append-inner-icon="
                        isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'
                      "
                      @click:append-inner="
                        isPasswordVisible = !isPasswordVisible
                      "
                    />
                  </VCol>

                  <VCol cols="12">
                    <AppTextField
                      v-model="form.newPwdCheck"
                      placeholder="請再次輸入新密碼"
                      :type="isPasswordVisible ? 'text' : 'password'"
                      :append-inner-icon="
                        isPasswordVisible ? 'tabler-eye-off' : 'tabler-eye'
                      "
                      @click:append-inner="
                        isPasswordVisible = !isPasswordVisible
                      "
                    />
                  </VCol>

                  <VCol cols="6">
                    <VBtn block variant="tonal"> 取消</VBtn></VCol
                  >
                  <VCol cols="6"
                    ><VBtn block type="submit" @click="updatePassword(form)">
                      確定變更
                    </VBtn></VCol
                  >

                  <!-- auth providers -->
                  <VCol cols="12" class="text-center">
                    <AuthProvider />
                  </VCol>
                </VRow>
              </VForm>
            </VCardText>
          </VCard>
        </div>
      </div>
    </VCol>
  </VRow>
</template>
